<template>
  <button @click="clicked" 
  :class="{
    'bg-color navbar-menu-item hover': true,
    'shrunk-button': !btnSettings.shrunk,
    [btnSettings.type]:true
  }">
    <span 
    :class="{
      'navbar-menu-link': true,
    }">
      <font-awesome-icon v-if="btnSettings.name" class="icon" :icon="['fa-solid',btnSettings.name]" />
      <div class="content" v-if="btnSettings.shrunk">
        <slot></slot>
      </div>

    </span>
  </button>
</template>

<script>
export default {
  name: 'my-shrunk-button',
  props:['btnSettings'],
  setup(){
    function clicked(){
      return
    }
    return{clicked}
  },
};
</script>

<style scoped>

.navbar-menu-item {
  height: 45px;
  font-size: 16px;
  border-radius: 7px;
  border: none;
}

.shrunk-button {
  width: 60px;
}

.bg-color{
  background-color: rgb(0,123,255);
  color: white;
}

.denied{
  background-color: rgb(220,44,44);
  color: white;
}

.success{
  background-color: rgb(60,230,81);
  color: #000;
}
.success:hover{
  background-color: rgb(60,230,81);
  color: white;
}

.navbar-menu-link {
  display: flex;
  align-items: center;
  justify-content: center;
}

.hover:hover:not(.active){
  background-color: #0056b3;
  cursor: pointer;
}

.pointer{
  cursor: pointer;
}

.active{
  background-color: rgba(79,70,229, 1);
  color: white ;
}

.right-component{
  padding-left:100px ;
}

.content {
  padding: 10px;
}

.icon{
  margin-left: 10px;
}
</style>
